






















































import Vue from 'vue';
import tutorial from '../src/components/tutorial.vue';
export default Vue.extend({
  components: { tutorial },
  name: 'App',

  data: () => ({
    tuto:false,

    
  }),
   methods: {
      mostrarTutorial(){
        this.$root.$emit('myEvent', true);
        // $data.tutorial=true;
        // this.$refs.tutorial.;
      },
      closeDialog(data : boolean){
        this.$data.tuto=data
      }
    },
    
  
});
